import { useMutation, useQueryClient } from 'react-query';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '@shared/lib/axios';
import type { TUser, TUseUpdateUserParams } from '@entities/user/lib/types';
import { QUERIES_INFO } from '@shared/lib/const';
import { useNotifications } from '@shared/notifications/model';
import { ENotificationType } from '@shared/notifications/lib';

export const useUpdateUser = ({ onSuccess }: TUseUpdateUserParams = {}) => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotifications();

  return useMutation<AxiosResponse<TUser>, unknown, TUser>(
    (user) => axiosInstance.put(QUERIES_INFO.user.endpoint.replace('[uuid]', user.id), user),
    {
      onSuccess: (response) => {
        showNotification({ type: ENotificationType.success, message: 'User data was successfully updated!' });
        queryClient.setQueryData([QUERIES_INFO.user.key, response.data.id], response.data);
        onSuccess?.();
      },
    },
  );
};
